import { AbgSxProps } from '@abg/typings';

export const headerImageContainer: AbgSxProps = {
  width: 'auto',
};
